import { ComponentProps } from "react"
import { preload } from "react-dom"
import { imageRequiresCdn } from "src/utilities/images"

const emptyImage = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="

export type ImgProps = Omit<ComponentProps<"img">, "src" | "alt" | "title"> & {
  src: string | null | undefined
  alt: string | null | undefined
  title?: string | null | undefined
}

export const Img = (props: ImgProps) => {
  if (process.env.NODE_ENV === "development") {
    if (imageRequiresCdn(props.src)) {
      console.warn("🖼️ Image is not proxied through CDN:", props.src)
    }
  }

  const fetchPriority: ComponentProps<"img">["fetchPriority"] =
    props.fetchPriority || props.loading === "eager" ? "high" : "auto"

  if (props.src && props.loading === "eager") {
    preload(props.src, {
      as: "image",
      imageSrcSet: props.srcSet,
      imageSizes: props.sizes,
      fetchPriority: fetchPriority,
    })
  }

  return (
    <img
      {...props}
      src={props.src || emptyImage}
      alt={props.alt || ""}
      title={props.title || ""}
      loading={props.loading || "lazy"}
      fetchPriority={fetchPriority}
      referrerPolicy="strict-origin-when-cross-origin"
    />
  )
}
